module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"goBackToPreviousPage":"Go back to previous page","qualificationsDashboard":"Status of qualifications"},"fr":{"goBackToPreviousPage":"Retour à la page précédente","qualificationsDashboard":"Etat des qualifications"}}')
  delete Component.options._Ctor
}
